import {createApp} from 'vue'
import App from './App.vue'
import Login from './Login.vue'
import axios from 'ts-axios-new'
import {createRouter, createWebHashHistory} from 'vue-router'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
import 'element-plus/dist/index.css'
import 'element-plus/theme-chalk/dark/css-vars.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import {update} from './libs/utils'
import {load_shared_data} from './libs/sharedData'
import {showHttpErrorDetail} from './libs/errorDisplay'
import './assets/styles/global.css'
import './assets/styles/page-shell.css'
import {routes} from './routes';

const useDirectApi = import.meta.env.VITE_DIRECT_API === 'true';
const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || '';
if (useDirectApi && apiBaseUrl) {
    axios.defaults.baseURL = apiBaseUrl;
}
axios.defaults.withCredentials = true;

const router = createRouter({
    history: createWebHashHistory(),
    routes
});

let login: any = null;
declare var google: any;
const GOOGLE_READY_RETRY_MS = 50;
const GOOGLE_READY_MAX_ATTEMPTS = 100;
let googleReadyAttempts = 0;

function mountLogin() {
    if (!login) {
        login = createApp(Login);
        login.mount('#login');
    }
}

export const root_props = {
    user: {
        avatar: '',
        name: '',
        email: '',
        role: 'user',
    },
    user_options: [],
    cdn_url: import.meta.env.VITE_CDN_URL || '',
};

function init() {
    const app = createApp(App);
    app.use(router);
    app.use(ElementPlus, {locale: zhCn});
    for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
        app.component(key, component)
    }
    const vm = app.mount('#app');
    update(vm, root_props);
}

export function completeLogin(user: any) {
    update(root_props.user, user);
    if (user.cdn_url) {
        root_props.cdn_url = user.cdn_url;
    }
    if (login) {
        login.unmount();
        login = null;
    }
    init();
    load_shared_data(root_props);
}

function bootAuth() {
    axios.get('/cms/v1/me', {
        headers: {
            'Cache-Control': 'no-cache',
            'Pragma': 'no-cache',
        },
        params: {
            _t: Date.now(),
        },
    }).then(res => {
        const me = res?.data?.data;
        if (!me || !me.email) {
            throw new Error('User is not logged in');
        }
        update(root_props.user, me);
        if (me.cdn_url) {
            root_props.cdn_url = me.cdn_url;
        }
        init();
        load_shared_data(root_props);
    }).catch(_ => {
        startGoogleLogin();
    });
}

function startGoogleLogin() {
        google.accounts.id.initialize({
            client_id: import.meta.env.VITE_OAUTH2_CLIENT_ID,
            callback: (response: any) => {
                console.log('[GSI] credential received, calling backend');
                axios.post('/cms/v1/oauth2/login', {
                    platform: 'google',
                    id_token: response.credential
                }).then(res => {
                    completeLogin(res.data.data);
                }).catch(err => {
                    console.error('[GSI] backend login failed', err?.response?.status, err?.response?.data || err);
                    showHttpErrorDetail(err, '登录失败', '登录失败，请重试');
                    mountLogin();
                });
            },
            auto_select: true,
            use_fedcm_for_prompt: true,
        });
        google.accounts.id.prompt((notification: any) => {
            try {
                const moment = notification.getMomentType && notification.getMomentType();
                const notDisplayedReason = notification.getNotDisplayedReason && notification.getNotDisplayedReason();
                const skippedReason = notification.getSkippedReason && notification.getSkippedReason();
                const dismissedReason = notification.getDismissedReason && notification.getDismissedReason();
                console.log('[GSI] prompt moment', {moment, notDisplayedReason, skippedReason, dismissedReason});
            } catch (e) {
                console.warn('[GSI] prompt moment inspect failed', e);
            }
            if (
                (notification.isDisplayMoment && notification.isDisplayMoment() && notification.isNotDisplayed && notification.isNotDisplayed()) ||
                (notification.isSkippedMoment && notification.isSkippedMoment()) ||
                (notification.isDismissedMoment && notification.isDismissedMoment())
            ) {
                mountLogin();
            }
        });
}

function runWhenGoogleReady() {
    if (typeof google === 'undefined' || !google?.accounts?.id) {
        googleReadyAttempts += 1;
        if (googleReadyAttempts >= GOOGLE_READY_MAX_ATTEMPTS) {
            mountLogin();
            return;
        }
        setTimeout(runWhenGoogleReady, GOOGLE_READY_RETRY_MS);
        return;
    }
    bootAuth();
}

if (document.readyState === 'complete') {
    runWhenGoogleReady();
} else {
    window.addEventListener('load', runWhenGoogleReady, {once: true});
}
